import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-orgchart',
  templateUrl: './orgchart.component.html',
  styleUrls: ['./orgchart.component.scss']
})
export class OrgchartComponent implements OnInit {
  constructor() {
  }

  ngOnInit(): void {
  }
}
